export { EventPage } from "./ui";
